export default __webpack_public_path__ + "static/media/ic-filter.f6c74b6b.svg";